module.exports = __webpack_public_path__ + "static/media/test_dientes_separados.cb551b71.jpg";